module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dwZBW"))).then(() => parcelRequire('1iHdE'));